<script lang="ts">
	import { NftRoutes } from '#lib/websites/nft/constants/routes.js';
	import { MediaCard } from '$global/components/MediaCard';
	import { Txt } from '$global/components/Txt';
	interface Props {
		dataCy: string;
		nftCollection: {
			title: string;
			slug: string;
			artist: string;
			featured_image: string;
		};
	}

	let { dataCy, nftCollection }: Props = $props();
</script>

<MediaCard
	dataCy={`${dataCy}-nft-collection`}
	variant="light"
	src={nftCollection.featured_image || ''}
	alt={nftCollection.title || ''}
	href={`${NftRoutes.Collections}/${nftCollection.slug}`}
	class="flex-grow"
	classes={{
		imageContainerClass: 'h-[10rem]',
		textContainerClass: 'pt-2 pb-3.5',
	}}
>
	{#snippet title()}
		<Txt dataCy={`${dataCy}-artist`} variant="body3" class="mb-1 text-gray-500"
			>{nftCollection.artist}</Txt
		>
	{/snippet}
	{#snippet description()}
		<Txt dataCy={`${dataCy}-title`} variant="strong1">{nftCollection.title}</Txt
		>
	{/snippet}
</MediaCard>
